import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/authentication/services/auth.service';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ApiCallMethodsService } from 'src/app/shared/services/api-call-methods.service';
import { LoaderService } from 'src/app/shared/services/loader-service/loader-service.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormBuilder, FormControl, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { MatDialog } from '@angular/material/dialog';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { MainService } from 'src/app/main/services/main.service';
import { DateAdapter } from '@angular/material/core';
import { SharedService } from 'src/app/shared/services/shared-service/shared.service';
import { SellService } from 'src/app/main/modules/sell-management/service/sell.service';
import { Subscription } from 'rxjs';
import { BusinessContactsService } from 'src/app/main/modules/business-contacts/service/business-contacts.service';

@Component({
  selector: 'app-customer-selection',
  templateUrl: './customer-selection.component.html',
  styleUrls: ['./customer-selection.component.scss']
})
export class CustomerSelectionComponent implements OnInit {
  @ViewChild(MatSelect) matSelect: MatSelect;
  @ViewChild(MatMenu) menu: MatMenu;
  @Output() refreshCalled: EventEmitter<void> = new EventEmitter();
  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;

  isInputActive: boolean = false;
  searchTerm: string = '';
  searchCustomer: string = '';
  orgId: any = null;
  invoiceListData: any = null;
  profitFilter: any;
  invoiceParamsId: any;
  isEditMode: boolean;
  pageSizeOptions: number[] = [10, 20, 50, 100];
  totalListCount: any;
  isLoading: boolean = false;
  overFilter: any;
  customerId: any = [];
  customerName: any = [];

  isCusApply: boolean = false;

  today: Date = new Date();

  paidAmount: any;
  paymentForm: FormGroup;
  currentDate: Date;
  paymentValue: any;
  customerList: any;
  noCus: boolean;
  dueDateOver: boolean = false;
  searchItem: any = '';
  paidNewAmount: void;
  payload: any = {
    id: [],
    details: []
  };
  cusPayload = {
    "contact_category": "Customer",
    "reg": "",
    "sort": "",
    "filter": "",
  };
  @Input() customerType: any;
  @Input() customerFrom: any;
  @Input() customerefreshCall: EventEmitter<void>;
  filterCustomer: any = null;
  sharingData: Subscription;
  contactListData: any;
  tempCustomerId: any[] = [];
  tempCustomerName: any[] = [];

  constructor(
    private apiCallMethodsService: ApiCallMethodsService,
    private alertService: AlertService,
    private router: Router,
    private authService: AuthService,
    private loaderService: LoaderService,
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private _snackBar: MatSnackBar,
    public mainService: MainService,
    private dateAdapter: DateAdapter<Date>,
    public sellManageService: SellService,
    private sharedService: SharedService,
    private contactService: BusinessContactsService
  ) {
    this.orgId = this.authService.getId();
    this.currentDate = new Date();

    dateAdapter.setLocale("en-in");

    this.paymentForm = this.formBuilder.group({
      iqp_payment_type: new FormControl('', Validators.compose([])),
      iqp_payment_ref: new FormControl('', Validators.compose([])),
      iqp_paid_date: new FormControl(this.currentDate, Validators.compose([])),
      notes: new FormControl('', Validators.compose([])),
      iqp_partly_pmnt_amnt: new FormControl('', Validators.compose([Validators.required])),
    });

    setTimeout(() => {
      this.isLoading = true;
      this.mainService.newCustomerList();
    }, 100);

    this.sharingData = this.mainService.SharingData.subscribe((response: any) => {
      this.isLoading = false;
      if (response.cusList) {
        this.customerList = response?.cusList?.customer || [];
        this.filterCustomer = [...this.customerList];
        if (this.customerId?.length > 0) {
          this.filterCustomer.forEach((item: any) => {
            item.isSelected = this.customerId.includes(item.contact_id);
          });
        }
      }
    });
  }

  onMenuOpened(): void {
    this.customerName = [...this.tempCustomerName];
    this.customerId = this.tempCustomerId.length > 0 ? [...this.tempCustomerId] : this.tempCustomerName.map(c => c.contact_id);
    this.searchCustomer = '';
    this.filterCustomer = [...(this.customerList || [])];
    this.filterCustomer.forEach((item: any) => {
      item.isSelected = this.customerId.includes(item.contact_id);
    });
  }

  onIconClick(event: MouseEvent): void {
    if (this.isCusApply) {
      event.stopPropagation();
      event.preventDefault();
      this.removeCusFilter(event);
    }
  }

  prevData(): void {
    this.customerName = [...this.tempCustomerName];
    this.customerId = this.tempCustomerId.length > 0 ? [...this.tempCustomerId] : this.tempCustomerName.map(c => c.contact_id);

    // Restore selection state in filterCustomer
    if (this.filterCustomer) {
      this.filterCustomer.forEach((item: any) => {
        item.isSelected = this.customerId.includes(item.contact_id);
      });
    }
    this.searchCustomer = '';
    this.filterCustomer = this.customerList ? [...this.customerList] : [];
  }

  getInvoiceList(value: any = null) {
    if (value == 2) {
      this.isCusApply = true;
    }
  }

  toggleCustomer(item: any, event?: Event): void {
    if (event) {
      event.stopPropagation();
    }
    item.isSelected = !item.isSelected;
    if (item.isSelected) {
      if (!this.customerId.includes(item.contact_id)) {
        this.customerId.push(item.contact_id);
        this.customerName.push(item);
      }
    } else {
      this.customerId = this.customerId.filter((id: any) => id !== item.contact_id);
      this.customerName = this.customerName.filter((c: any) => c.contact_id !== item.contact_id);
    }
  }

  onCheckboxChange(selectedItem: any) {
    if (selectedItem.isSelected) {
      if (!this.customerId.includes(selectedItem.contact_id)) {
        this.customerId.push(selectedItem.contact_id);
        this.customerName.push(selectedItem);
      }
    } else {
      this.customerId = this.customerId.filter((id: any) => id !== selectedItem.contact_id);
      this.customerName = this.customerName.filter((item: any) => item.contact_id !== selectedItem.contact_id);
    }
  }

  filterByCustomer(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.isCusApply = this.customerId.length > 0;
    this.payload.id = this.customerId;
    this.payload.details = this.customerName;

    this.tempCustomerId = [...this.customerId];
    this.tempCustomerName = [...this.customerName];
    this.sharedService.selectedCustomerFilter({ ...this.payload, customerFrom: this.customerFrom });
    if (this.trigger) {
      this.trigger.closeMenu();
    }
  }

  onInputFocus() {
    this.isInputActive = true;
  }

  onInputBlur() {
    this.isInputActive = false;
  }

  deSelectFilter() {
    this.customerList?.forEach((item: any) => {
      item.isSelected = false;
    });
  }

  applyFilter(event: any) {
    const filterValue = (event?.target as HTMLInputElement)?.value ?? '';
    this.searchCustomer = filterValue;

    if (!filterValue || filterValue.trim() === '') {
      this.filterCustomer = [...(this.customerList || [])];
      return;
    }

    this.filterCustomer = (this.customerList || []).filter((customer: any) =>
      customer.contact_first_name?.toLowerCase().includes(filterValue.toLowerCase())
    );
  }

  clearSearch(event?: any) {
    if (event) {
      this.stopPropagation(event);
    }
    this.searchCustomer = '';
    this.filterCustomer = [...(this.customerList || [])];
  }

  removeCusFilter(event?: Event) {
    if (event) {
      this.stopPropagation(event);
    }
    this.customerName = [];
    this.customerId = [];
    this.tempCustomerName = [];
    this.tempCustomerId = [];
    this.isCusApply = false;
    this.searchCustomer = '';
    this.deSelectFilter();
    this.payload.id = this.customerId;
    this.payload.details = this.customerName;
    this.filterCustomer = [...(this.customerList || [])];

    this.sharedService.selectedCustomerFilter({ ...this.payload, customerFrom: this.customerFrom, remove: true });
    if (this.trigger) {
      this.trigger.closeMenu();
    }
  }

  ngOnInit() {
    this.customerName = [];
    this.customerId = [];
    this.tempCustomerName = [];
    this.tempCustomerId = [];
    this.isCusApply = false;
    this.searchCustomer = '';
    this.deSelectFilter();
    this.filterCustomer = this.customerList ? [...this.customerList] : [];

    this.payload.id = this.customerId;
    this.payload.details = this.customerName;

    this.sharedService.selectedCustomerFilter({ ...this.payload, customerFrom: this.customerFrom });

    if (this.customerefreshCall) {
      this.customerefreshCall.subscribe(() => {
        this.customerName = [];
        this.customerId = [];
        this.tempCustomerName = [];
        this.tempCustomerId = [];
        this.isCusApply = false;
        this.searchCustomer = '';
        this.filterCustomer = this.customerList ? [...this.customerList] : [];
        this.deSelectFilter();
        this.payload.id = this.customerId;
        this.payload.details = this.customerName;

        this.sharedService.selectedCustomerFilter({ ...this.payload, customerFrom: this.customerFrom });
      });
    }
  }

  stopPropagation(event: Event): void {
    if (event) {
      event.stopPropagation();
    }
  }

  get isInputNotEmpty(): boolean {
    return (this.searchCustomer || '').trim() !== '';
  }
}
